import { render, staticRenderFns } from "./SnkrBlog.vue?vue&type=template&id=39ea1502&"
import script from "./SnkrBlog.vue?vue&type=script&lang=js&"
export * from "./SnkrBlog.vue?vue&type=script&lang=js&"
import style0 from "./SnkrBlog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports